import React from "react";
import { EmbedProviderProps } from "./EmbedProviders";
import { useColorScheme } from "../LiveblogRenderContext";
import ExecutableProvider from "./ExecutableProvider";

export function DatawrapperProvider(props: EmbedProviderProps) {
  const { oembed } = props;
  const colorScheme = useColorScheme();

  let modifiedOembed = oembed;

  if ((colorScheme === 'dark' || colorScheme === 'auto') && oembed.html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = oembed.html;

    const iframe = tempDiv.querySelector('iframe');

    if (iframe) {
      const currentStyle = iframe.getAttribute('style') || '';
      if (!currentStyle.includes('color-scheme:')) {
        iframe.setAttribute('style', `color-scheme:light dark;${currentStyle}`);
      }
    }

    modifiedOembed = {
      ...oembed,
      html: tempDiv.innerHTML
    };
  }

  return <ExecutableProvider {...props} oembed={modifiedOembed} />;
}

export default DatawrapperProvider;
